import { takeLatest, call, put, select } from 'redux-saga/effects'

import {
  updateConfigJson,
  errorConfigJson,
  CONFIG_JSON_GET,
  updateMeta,
  errorMeta,
  META_GET,
  updateUserData,
} from 'actions/general'

import { generalStateSelector } from 'selectors/redux-selectors'
import needsGeneralState from 'util/needs-general-state'

function _getConfigJson({ fetch }, logError) {
  return function*(action) {
    try {
      const configJsonEndpoint = '/api/config.json'

      const configJsonResult = yield call(fetch, configJsonEndpoint)
      yield put(
        updateConfigJson({
          data: configJsonResult,
        })
      )

      const generalState = yield select(generalStateSelector)
      if (needsGeneralState(generalState)) {
        const orgslug =
          configJsonResult &&
          configJsonResult.auth &&
          configJsonResult.auth.org &&
          configJsonResult.auth.org.slug
            ? configJsonResult.auth.org.slug
            : null
        const username =
          configJsonResult &&
          configJsonResult.auth &&
          configJsonResult.auth.user &&
          configJsonResult.auth.user.username
            ? configJsonResult.auth.user.username
            : null

        yield put(
          updateUserData({
            orgslug,
            username,
          })
        )
      }
    } catch (err) {
      yield call(logError, err)

      yield put(
        errorConfigJson({
          error: true,
        })
      )
    }
  }
}

function _getMeta({ fetch }, logError) {
  return function*(action) {
    try {
      const orgslug = action.payload.orgslug
      const metaEndpoint = `/api/v1/org/${orgslug}/meta`
      const metaResult = yield call(fetch, metaEndpoint)

      yield put(
        updateMeta({
          data: metaResult,
        })
      )
    } catch (error) {
      yield call(logError, error)

      yield put(
        errorMeta({
          error: true,
        })
      )
    }
  }
}

export const Test = {
  _getConfigJson,
  _getMeta,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchGetConfigJson(api, error) {
  yield takeLatest(CONFIG_JSON_GET, _getConfigJson(api, error))
  yield takeLatest(META_GET, _getMeta(api, error))
}
